import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Pencil.svg'

export const IconPencil = IconSVG as IconComponent
